(() => {
  if (customElements.get('scent-option-feedback')) return;
  const palettes = {
    pineforest: '#e8ede3', lavendergarden: '#eee8f4', lemonsherbet: '#fff4cc', lemonsherbert: '#fff4cc',
    rosefloral: '#f5e5e8', freshcitrus: '#fbe9d6',
    '파인포레스트': '#e8ede3', '라벤더가든': '#eee8f4', '레몬셔벗': '#fff4cc',
    '로즈플로럴': '#f5e5e8', '프레시시트러스': '#fbe9d6', '프레쉬시트러스': '#fbe9d6', '레몬샤베트': '#fff4cc',
    starlight: '#f5f1e7', silver: '#f5f1e7', '스타라이트': '#f5f1e7', '실버': '#f5f1e7',
    paleblue: '#e5eef2', pearblue: '#e5eef2', '페일블루': '#e5eef2',
    woodorange: '#f5e2d1', '우드오렌지': '#f5e2d1'
  };
  const normalize = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9가-힣]/g, '');
  const matchPalette = value => {
    const key = normalize(value);
    if (palettes[key]) return palettes[key];
    const match = Object.keys(palettes).find(name => key.startsWith(name) || key.endsWith(name));
    return match ? palettes[match] : null;
  };
  customElements.define('scent-option-feedback', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info[data-scent-options]');
      this.picker = this.closest('variant-selects');
      if (!this.root || !this.picker) { this.hidden = true; return; }
      this.onChange = () => this.update();
      this.picker.addEventListener('change', this.onChange);
      // Also runs after Shopify replaces the picker with its server response.
      queueMicrotask(() => { if (this.isConnected) this.update(); });
    }
    disconnectedCallback() {
      this.picker?.removeEventListener('change', this.onChange);
    }
    update() {
      const selected = [...this.picker.querySelectorAll('input[type="radio"]:checked, select')]
        .map(input => {
          const option = input.tagName === 'SELECT' ? input.selectedOptions[0] : input;
          return { name: option?.dataset.optionName || input.name, value: input.value };
        });
      const text = selected.map(item => `${item.name}: ${item.value}`).join(' · ');
      const output = this.querySelector('[data-scent-selection-text]');
      if (output && output.textContent !== text) output.textContent = text;
      const color = selected.find(item => /^(scent|fragrance|향|향기)$/i.test(item.name.trim()) && matchPalette(item.value)) ||
        selected.find(item => matchPalette(item.value));
      const background = matchPalette(color?.value) || '#f5f1e7';
      this.root.style.setProperty('--scent-option-background', background);
      const page = this.root.closest('[data-scent-refill-page]');
      if (page) page.style.setProperty('--scent-refill-background', background);

    }
  });
})();
